import { For, Show } from "solid-js";
import { activeOpenToKeys, OPEN_TO_LABELS, type OpenToFlags } from "~/lib/open-to";

type Props = {
  flags?: OpenToFlags | null;
};

export function OpenToBadges(props: Props) {
  const items = () => activeOpenToKeys(props.flags);

  return (
    <Show when={items().length}>
      <div class="open-to-row">
        <For each={items()}>{(key) => <span class="open-to-badge">{OPEN_TO_LABELS[key]}</span>}</For>
      </div>
    </Show>
  );
}
